<template>
  <div class="ll-question-list" :class="{'no-margin-top':noMarginTop}">
    <p class="ll-question-list_title">
      {{ chapterCustomedIndex }}{{ title }}
    </p>
    <div class="ll-question-list_content">
      <div
        v-for="(list,listIndex) in questionList"
        :key="listIndex"
        class="ll-question-list_content-item"
      >
        <p
          v-if="list.title"
          class="ll-question-list_category-title ml-10"
        >
          {{ list.sectionCustomedIndex }}{{ list.title }}
        </p>
        <div class="ll-question-list_questions">
          <div
            v-for="(question,quesIndex) in list.questionList"
            :key="quesIndex"
            class="ll-question-list_question"
          >
            <ErrorChecklistQuestion
              v-if="!question.score && error"
              :error="error"
              :ques-num="question.questionCustomedIndex"
              :title="question.title"
              @error-click="$_onClick(question)"
            />
            <ChecklistQuestion002
              v-else
              :ref="`ChecklistQuestion${listIndex}${quesIndex}`"
              :ocap-content="ocapContent"
              :upload-url="uploadUrl"
              :editable="editable"
              :hide-focus="hideFocus"
              :hide-subtitle="hideSubtitle"
              :annex="hasAnnex"
              :ques-result="quesResult"
              :title="question.title"
              :subtitle="question.subtitle"
              :ques-type="question.quesType"
              :remark="question.remark"
              :images="question.images"
              :attaches="question.attaches"
              :ocap-remark="question.ocapRemark"
              :ocap-attaches="question.ocapAttaches"
              :law-list="question.lawList"
              :ques-num="question.questionCustomedIndex"
              :text-label="textLabel"
              :content-icon="contentIcon"
              :has-bottom-btn="hasBottomBtn"
              :focus="question.focus"
              :control-limit-data="question.controlLimitData"
              :spec-limit-data="question.specLimitData"
              :score="question.score"
              :alert-text="question.alertText"
              :risk-signal="question.riskSignal"
              :botton-btn-text="bottonBtnText"
              :remark-validate-rule="remarkValidateRule"
              :is-all-drop-down="isAllDropDown"
              :uploadModule="uploadModule"
              :tempAttaches="question.tempAttaches"
              :chips="question.chips"
              :isInStats="question.isInStats"
              :newQuesType="question.newQuesType"
              :option="question.option"
              :optionList="question.optionList"
              :condition="question.condition"
              :conditionList="question.conditionList"
              :unit="question.unit"
              :guidelineList="question.guidelineList"
              @bottom-btn-click="$_bottomBtnClick(question)"
              @law-click="$_onClickLaw($event)"
              @editable-btn-submit="$_editableBtnSubmit($event,question)"
              @fetch-question="$_fetchQuestion(question,listIndex,quesIndex,`ChecklistQuestion${listIndex}${quesIndex}`)"
              @guideline-click="$_onClickRelatedGuideline($event)"
            />
          </div>
        </div>
      </div>
    </div>
    <LlActPopup
      :is-loading="isLoading.lawPopup"
      :law-content="lawContent"
      :popup-active="isActive.lawPopup"
      @popup-close="$_onClosePopup('lawPopup')"
    />
    <LvPopupInfoArticle
      ref="LvPopupInfoArticle"
    />
  </div>
</template>
<script>
import S_article from "@/service/api/v1/article";
import H_guideline from '@/helpers/guideline';

export default {
  name: "LlQuestionList002",

  props: {
    remarkValidateRule: {
      type: Boolean,
      default: false,
    },
    chapterCustomedIndex: {
      type: String,
      default: "",
    },
    ocapContent: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "",
    },
    bottonBtnText: {
      type: String,
      default: "",
    },
    questionList: {
      type: Array,
      default() {
        return [];
      },
    },
    editable: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    categoryTitle: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    contentIcon: {
      type: String,
      default: "",
    },
    result: {
      type: Boolean,
      default: false,
    },
    quesResult: {
      type: Boolean,
      default: false,
    },
    hasAnnex: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: "",
    },
    errorIcon: {
      type: String,
      default: "",
    },
    hasBottomBtn: {
      type: Boolean,
      default: false,
    },
    hideFocus: {
      type: Boolean,
      default: false,
    },
    hideSubtitle: {
      type: Boolean,
      default: false,
    },
    isAllDropDown: {
      type: Boolean,
      default: false,
    },
    fetchQuesFunc: {
      //fetch question content api
      type: Function,
    },
    noMarginTop: {
      type: Boolean,
      default: false,
    },
    uploadModule: {
      type: String,
    }
  },
  data() {
    return {
      isLoading: {
        lawPopup: false,
      },
      isActive: {
        lawPopup: false,
      },
      lawContent: {},
    }
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factory.id;
    }
  },
  methods: {
    $_editableBtnSubmit($event, question) {
      const editableContent = {};
      editableContent.images = $event.images;
      editableContent.remark = $event.remark;
      editableContent.questionId = question.id;
      this.$emit("editable-btn-submit", editableContent);
    },
    $_onClick(question) {
      this.$emit("error-click", question);
    },
    async $_onClickLaw($event) {
      this.lawContent = {};
      const {type, id, versionId} = $event;
      if (type === "act") {
        const url = this.$router.resolve({
            path: `/factory/${this._currentFactoryId}/act-content-main/${id}`,
          });
        window.open(url.href, "_blank");
      } else {
        this.$_onOpenPopup('lawPopup');
        this.isLoading.lawPopup = true;
        const article = await S_article.getLawContent(
          this._currentFactoryId,
          versionId,
        );
        this.lawContent = S_article.getLawData(article);
        this.isLoading.lawPopup = false;
      }
    },
    $_bottomBtnClick(question) {
      this.$emit("bottom-btn-click", question);
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      this.isActive[type] = false;
    },
    async $_fetchQuestion(ques, listIndex, quesIndex, ref) {
      if (!this.fetchQuesFunc || ques.hasFetch) return;
      // if (!this.fetchQuesFunc) return;
      if (ref) {
        this.$refs[ref][0].$_loadingStart();
      }
      const version = await this.fetchQuesFunc(ques);
      const quesList = [...this.questionList]
      quesList[listIndex].questionList[quesIndex] = {
        ...ques,
        ...version,
        hasFetch: true,
      }
      this.$emit('fetch-question', {quesList, listIndex, quesIndex})
      if (ref) {
        this.$refs[ref][0].$_loadingEnd();
      }
    },
    async $_onClickRelatedGuideline($event) {
      await H_guideline.clickRelatedGuideline(this, $event);
    }
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-question-list";
</style>